export default __webpack_public_path__ + "static/home-01-01-db66fd893702e44ee87a217ee9065a4d.jpg";